import Uploader from './uploader';
import React from 'react';
type TUploadImageProps = {
  images: Array<IUploadImage>;
  setImages: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
};

const UploadImage = ({images, setImages}: TUploadImageProps) => {
  return (
    <>
      <div className="mt-1 flex w-full justify-center">
        <Uploader images={images} setFile={setImages} />
      </div>
    </>
  );
};

export default UploadImage;
